import React, { Component } from "react";
import Dialog from "../dialog";
import DialogInput from "../input";
import DialogInputBox from "../inputbox";
import DialogUpload from "../uploadfile";
import LanguageInput from "../languagesinput";
import SelectSequence from "../../appcode/appcomponents/sequences/selectsequence/selectsequence";
import VideoAudioAnalyzer from "./videoaudioanalyzer";
import { getCurrentUserDatas } from "../../../utils/software";
import language from "react-syntax-highlighter/dist/esm/languages/hljs/1c";

class AddVideo extends Dialog
{
  constructor(props) 
  {
    super(props);

    const title = {
        en:"Add a video file", 
        fr:"Ajouter un fichier vidéo",
      };
    this.state.title = title;
    this.state.usetranscription = false;
    this.state.usescenario = false;
    this.state.cantconvert = false;
    this.state.cantextractcp = false;
    this.state.cantextracttext = false;


    this.state.buttons = 
    [
      //{type:"text", disabled:true,text:{fr:"Accepter",en:"Accept"},key:"accept"},
      //{type:"text", disabled:false,text:{fr:"Refuser",en:"Decline"}, key:"decline"},
      {type:"back", disabled:false},
      {type:"ok", disabled:true},
      
    ]

    this.handleButton =  this.handleButton.bind(this);
    this.onClickOnSequence = this.onClickOnSequence.bind(this)

    this.sceoptiontiret = false;

    var asidpdf = 0;
      this.props.assetsList.forEach((element,index) => {
          if ( (asidpdf === 0) &&  (element.astype === 9)) asidpdf = element.asid;
      });

      


    this.formulaire = 
      {
        title: "",
        convert: false,
        audio: true,
        cp: true,
        transcription: false,
        transcriptiontype: 1 ,
        simp: false,
        sce: false,
        texts: false,
        filename: "",
        uploadfile: null,
        iduser: getCurrentUserDatas().id,
        language: "fr-FR",
        sceasidpdf: asidpdf,
      }
   

      if (this.props.videofile !== null)
      {
        this.formulaire.uploadfile = this.props.videofile;
        this.formulaire.title = this.removeExtension(this.props.videofile.name);
        
        const ext =  this.getExtension(this.props.videofile.name);
        if (( ext==="mp3") || (ext === "wav"))
        {
          this.state.cantconvert = true;
          this.state.cantextractcp = true;
          this.state.cantextracttext = true;
          this.formulaire.cp = false;

        }

        if ((ext === "wmv") || (ext === "mpg") || (ext==="mpeg"))
        {
          this.formulaire.convert = true;
          this.state.cantconvert = true;
        }


      }




      this.titleRef = React.createRef();
      this.convertRef = React.createRef();
      this.audioRef = React.createRef();
      this.cpRef = React.createRef();
      this.transcriptionRef = React.createRef();
      this.transcriptiontypeRef = React.createRef();
      this.textsRef = React.createRef();
      this.sceRef = React.createRef();
      this.simpRef =React.createRef();
      this.uploadRef = React.createRef();
      this.filenameRef = React.createRef();
      this.languageRef = React.createRef();
      this.sceoptiontiretRef = React.createRef();

      this.handleOnChange = this.handleOnChange.bind(this);

      this.onQuit = this.onQuit.bind(this)
      this.onValid = this.onValid.bind(this)


   
    
  }

  onClickOnSequence( item, index)
  {
    this.formulaire.sceasidpdf = item.asid;
    
  }

  getExtension(filename) {
    return filename.split('.').pop().toLowerCase();
  }


  onValid()
  {
    
  }

  onQuit()
  {
    this.props.onButton("back", this.formulaire);    
  }

  removeExtension(filename) 
    {
      const index = filename.indexOf(".");
      if (index === -1) return filename;
      return filename.split('.').slice(0, -1).join('.');
    }

  handleOnChange()
  {
      this.formulaire.title = this.titleRef.current.getValue();
      this.formulaire.convert = this.convertRef.current.getValue();
      this.formulaire.audio = this.audioRef.current.getValue();
      this.formulaire.cp = this.cpRef.current.getValue();
      this.formulaire.transcription = this.transcriptionRef.current.getValue();
      this.formulaire.language = this.languageRef.current.getValue();

      this.formulaire.sceopt = 0;
      if (this.sceoptiontiretRef.current.getValue()) this.formulaire.sceopt = this.formulaire.sceopt + 1;
      if (this.formulaire.language.length>2) this.formulaire.language = this.formulaire.language.substring(0,2);

      this.formulaire.sce = this.sceRef.current.getValue();

      this.formulaire.simp = this.simpRef.current.getValue();;
      this.formulaire.simpopt = 0;
      
      


      

      this.formulaire.transcriptiontype = (this.transcriptiontypeRef.current.getValue()?1:0);

      if (this.formulaire.transcription != this.state.usetranscription)
        this.setState({usetranscription: this.formulaire.transcription});

      if (this.formulaire.sce != this.state.usescenario)
        this.setState({usescenario: this.formulaire.sce});

      this.formulaire.texts = this.textsRef.current.getValue();
      if (this.props.videofile === null) this.formulaire.uploadfile = this.uploadRef.current.getValue();

      if (this.formulaire.uploadfile != null)
      {
          this.filenameRef.current.setValue(this.formulaire.uploadfile.name)
          if (this.formulaire.title.trim() === "")
          {
            this.formulaire.title = this.removeExtension(this.formulaire.uploadfile.name);
            this.titleRef.current.setValue(this.formulaire.title);
          }
      }



      




      if ((this.formulaire.title.trim() != "")
        && (this.formulaire.uploadfile != null))
      {
        this.setDisabledButtonByType("ok", false);
        this.setDisabledButtonByKey("accept", false);
      }
      else
      {
        this.setDisabledButtonByType("ok", true);
        this.setDisabledButtonByKey("accept", true);
      }

      
      
  }


  handleButton(buttonkey)
  {
    
    this.props.onButton(buttonkey, this.formulaire);

    
  }

  render()
  {

    var dropfileinput = [[]]
    if (this.props.videofile === null)
    {
      dropfileinput.push(
        <DialogUpload
        validFiles = {["mp4","mpg","mpeg","mov","avi","webm"]}
        ref = {this.uploadRef}
        width = "400px"
        onChange =  {this.handleOnChange}
      />

        
      )
    }

    const retour =
    (
      <>

      <VideoAudioAnalyzer
          file = {this.props.videofile}
          onAnalysisComplete={({ file, audioTracks, audioTrackCount }) => {
              console.log("Fichier :", file.name);
              console.log("Nombre de pistes :", audioTrackCount);
              console.log("Pistes audio :", audioTracks);

              // Ici, tu peux autoriser l'upload
              // ou avertir l'utilisateur si plusieurs pistes existent.
          }}
      />      
      <br/><br/>
        <DialogInput
          value = {this.formulaire.title}
          disabled={false}
          autoFocus = {true}
          title = {this.context.language=="fr"?"Titre":"Title"}
          width = "400px"
          ref = {this.titleRef}
          onChange =  {this.handleOnChange}

        />

      <br/>
      <DialogInputBox
                value = {this.formulaire.convert}
                disabled={this.state.cantconvert}
                autoFocus = {false}
                onChange =  {this.handleOnChange}
                ref = {this.convertRef}
                title = {this.context.language=="fr"?"Convertir en mp4":"Convert to MP4"}
              />
      <br/>
      <DialogInputBox
                value = {this.formulaire.audio}
                disabled={false}
                autoFocus = {false}
                ref = {this.audioRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Extraire les audios":"Extract Audio Tracks"}
              />
      <br/>
      <DialogInputBox
                value = {this.formulaire.cp}
                disabled={this.state.cantextractcp}
                autoFocus = {false}
                ref = {this.cpRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Chercher les changements de plan":"Extract Shots"}
              />
      
      <br/><br/>
      <DialogInputBox
                value = {this.formulaire.transcription}
                disabled={false}
                autoFocus = {false}
                ref = {this.transcriptionRef}
                
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Extraire la transcription":"Extract transcription"}
              />
      <br/>
        <LanguageInput
                value = {this.formulaire.language}
                disabled={!this.state.usetranscription}
                autoFocus = {false}
                ref = {this.languageRef}
                onChange =  {this.handleOnChange}
                readOnly = {false}
                width = "400px"
                title = {this.context.language=="fr"?"Langage":"Language"}
              />
      <br/><br/>

      <DialogInputBox
                value = {this.formulaire.transcriptiontype != 0}
                disabled={!this.state.usetranscription}
                autoFocus = {false}
                ref = {this.transcriptiontypeRef}
                decale = {true}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Utiliser la transcription DAIA":"Use DAIA transcript"}
              />

      <br/>

      <DialogInputBox
                value = {this.formulaire.sce}
                disabled={!this.state.usetranscription || this.formulaire.sceasidpdf < 1}
                autoFocus = {false}
                ref = {this.sceRef}
                decale = {true}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Utiliser un scénario PDF":"Use scenario PDF file"}
              />
      <br/>
      <DialogInputBox
                value = {this.sceoptiontiret}
                disabled={!this.state.usescenario}
                autoFocus = {false}
                ref = {this.sceoptiontiretRef}
                decalevalue = "40px"
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Tirets":"Dashes"}
              />

      <br/>
      <div style = {{width:"calc(100% - 38px)", marginLeft:"20px", marginBottom:"5px"}}>
     <SelectSequence onClick = {this.onClickOnSequence} list = {this.props.assetsList} type={9}/>
      </div>
      <DialogInputBox
                value = {this.formulaire.simp}
                disabled={!this.state.usetranscription}
                autoFocus = {false}
                ref = {this.simpRef}
                decale = {true}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Utiliser la simplification":"Use simplifier"}
              />

      <br/><br/>


      <DialogInputBox
                value = {this.formulaire.texts}
                disabled={this.state.cantextracttext}
                autoFocus = {false}
                ref = {this.textsRef}
                onChange =  {this.handleOnChange}
                title = {this.context.language=="fr"?"Rechercher les textes dans l'image":"Look for on-screen texts"}
              />







      <br/>
      <DialogInput
                value = {this.formulaire.filename}
                disabled={false}
                autoFocus = {false}
                ref = {this.filenameRef}
                onChange =  {this.handleOnChange}
                readOnly = {true}
                width = "400px"
                title = {this.context.language=="fr"?"Fichier à téléverser":"File to upload"}
              />



      {dropfileinput}

      </>
    )

    return super.render(retour);
  }


}
AddVideo.defaultProps = 
{ 
  videofile:null,
}


export default AddVideo;